<template>
<div id="navbar_">
    <div class="container">
        <div class="row" style="position: relative;">
            <div class="left">  
                <span @click="swipeLeft">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13"  viewBox="0 0 6.1 9.4">
                            <defs>
                                <clipPath id="clip-path">
                                <rect width="6.1" height="9.4" fill="none"/>
                                </clipPath>
                            </defs>
                            <g id="Arrow_Small_Left" data-name="Arrow Small Left" clip-path="url(#clip-path)">
                                <path id="Path_36" data-name="Path 36" d="M6.7,8.1,2,3.4,3.4,2,6.7,5.3,10,2l1.4,1.4Z" transform="translate(8.1 -2) rotate(90)" fill="#700e57"/>
                            </g>
                            </svg> 
                </span> 
            </div>
            <div class="center filter" ref="content"  >
                <div class="internal">
                <strong> {{ $t('Cuisine')}}</strong>   
                </div>  
                <div class="internal"
                @click="onSelectCuisine(cuisine)"
                :class="{ active: cursine_selected.id === cuisine.id}"
                v-for="cuisine of cuisines" :key="cuisine.id">
                    {{ cuisine.name}}
                </div> 
            </div>
            <div class="right"> 
                <span @click="swipeRight">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="13"   viewBox="0 0 6.1 9.4">
                        <defs>
                            <clipPath id="clip-path">
                            <rect width="6.1" height="9.4" fill="none"/>
                            </clipPath>
                        </defs>
                        <g id="Arrow_Small_Left" data-name="Arrow Small Left" transform="translate(6.1 9.4) rotate(180)" clip-path="url(#clip-path)">
                            <path id="Path_36" data-name="Path 36" d="M6.7,8.1,2,3.4,3.4,2,6.7,5.3,10,2l1.4,1.4Z" transform="translate(8.1 -2) rotate(90)" fill="#700e57"/>
                    </g>
                    </svg> 
                </span>
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <ul class="list-group list-group-horizontal filter">
                <li class="list-menu m-2"> 
                    <strong> {{ $t('Meal')}}</strong>
                </li>
                <li class="list-menu m-2" :class="{ active: meal_selected.id === meal.id}" v-for="meal of meals" :key="meal.id"
                @click="onSelectMeal(meal)">
                    {{ meal.name }}
                </li>
                
            </ul> 
        </div>   
    </div>  
</div>
</template>
<style lang="css"> 
    .filter > .active {
        background: #700E57;
        color: white;
        padding: 0px 5px 0px 5px;
        border-radius: 28px;
    }
    .menu-wrapper {
        position: relative;
        max-width: 100%; 
        overflow-x: hidden;
        overflow-y: hidden;
        padding-left: 10px;
        padding-right: 10px;
        align-items: center;
        justify-content: center;
    }
    .menu	{  
        box-sizing: border-box; 
        white-space: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch; 
    }
    .menu >  .item {
          display: inline-block;
          width: 100px;
          height: 100%;
          outline: 1px dotted gray;
          padding: 1em;
          box-sizing: border-box;
      }
    .list-menu{
      list-style: none;
      white-space: nowrap;
    }
    .right{
        margin-top: 10px;
        margin-right: 10px;
        right: 0;
        position: absolute;
    }
    .left{
        position: absolute;
        margin-left: 10px;
        margin-top: 10px;
    }
    .internal {
        padding: 10px; 
        display: inline-block;
        cursor: pointer; 
    }

    .center {
        float: left;
        width: 80%;
        height: 50px; 
        margin: 1px;
        overflow: auto; 
        white-space: nowrap;
        text-align: center;
    } 
    .center::-webkit-scrollbar {
        display: none;
    }
    .sticky { 
        position: -webkit-sticky;
        position: sticky;
        top: -1px; 
        width: 100%;
        z-index: 6;
        background: white;
        transition: background 0.3s;
        box-shadow: 0 0.125rem 0.25rem rgb(0 0 0 / 8%) !important;
    } 
    .sticky + .content {
        padding-top: 150px;
    }
</style>

<script>
    import store from '@/store' 
    export default {
        name: "menuScroll",
        props:['data'],
        data: () => ({
            cursine_selected: {},
            meal_selected: {}
        }), 
        computed: { 
            meals() {
                if(!this.data) return []
                return this.data.meals;
            },
            cuisines() {
                if(!this.data) return []
                return this.data.cuisines;
            },
            seletedFilters(){
                return  store.getters["main_location/seletedFilters"];
            }
        },
        methods: {
            scrollTo(element, scrollPixels, duration) {
                const scrollPos = element.scrollLeft;
                // Condition to check if scrolling is required
                if (!((scrollPos === 0 || scrollPixels > 0) && (element.clientWidth + scrollPos === element.scrollWidth || scrollPixels < 0))) {
                    // Get the start timestamp
                    const startTime = "now" in window.performance ? performance.now() : new Date().getTime();

                    function scroll(timestamp) {
                        //Calculate the timeelapsed
                        const timeElapsed = timestamp - startTime;
                        //Calculate progress
                        const progress = Math.min(timeElapsed / duration, 1);
                        //Set the scrolleft
                        element.scrollLeft = scrollPos + scrollPixels * progress;
                        //Check if elapsed time is less then duration then call the requestAnimation, otherwise exit
                        if (timeElapsed < duration) {
                            //Request for animation
                            window.requestAnimationFrame(scroll);
                        } else {
                            return;
                        }
                    }
                    //Call requestAnimationFrame on scroll function first time
                    window.requestAnimationFrame(scroll);
                }
            },
            swipeLeft() {
                const content = this.$refs.content;
                this.scrollTo(content, -300, 800);
            },
            swipeRight() {
                const content = this.$refs.content;
                this.scrollTo(content, 300, 800);
            },
           async emit(){
                let data = {
                     cuisines: this.cursine_selected,
                     meal: this.meal_selected
                 }  
                this.$emit("input", data);
                await  this.$store.dispatch('main_location/updateFilter', data)
            },
            onSelectCuisine(selected){
                if(selected.id == this.cursine_selected.id){ 
                    this.cursine_selected = {
                          id: null
                    } 
                }else{
                    this.cursine_selected = selected
                }
               
                this.emit()
            },
            onSelectMeal(selected){

                if(selected.id == this.meal_selected.id){
                    this.meal_selected = {
                        id: ''
                    }
                }else{
                    this.meal_selected = selected
                }
                this.emit()
            },
            sticky(){
                try {
                     var navbar = document.getElementById("navbar_");
                    // var sticky = navbar.offsetTop; 
                    if (window.pageYOffset >= 300) {
                        navbar.classList.add("sticky")
                    } else {
                        navbar.classList.remove("sticky");
                    }
                } catch (error) {
                    
                }
               
            },
            menu(){
                if(this.seletedFilters.cuisines){
                    this.cursine_selected.id = this.seletedFilters.cuisines.id
                }
                if(this.seletedFilters.meal){
                    this.meal_selected.id = this.seletedFilters.meal.id
                }
            }
            
        },
        // watch:{
        //     cursine_selected: function () {
        //         this.emit()
        //     },
        //     meal_selected: function () {
        //        this.emit()
        //     },

        // },
        mounted(){ 
            this.menu()
            window.document.onscroll = () => {
                this.sticky()
            }
            
        },
        
    };
</script>
